import { useRef, useState } from "react";
import { toast } from "sonner";
import { Download, Loader2, FileSpreadsheet } from "lucide-react";
import { api, empFieldsTemplateUrl } from "../lib/api";

export const EmployeeFieldsImport = ({ onDone }) => {
  const [busy, setBusy] = useState(false);
  const [res, setRes] = useState(null);
  const ref = useRef();
  const upload = async (f) => {
    if (!f) return;
    setBusy(true); setRes(null);
    try {
      const r = await api.importEmpFields(f);
      setRes(r);
      toast.success(`حُدّث ${r.updated} · أُضيف ${r.created || 0} موظف${r.not_found.length ? ` · ${r.not_found.length} بدون اسم` : ""}`);
      onDone?.();
    } catch (e) { toast.error(e?.response?.data?.detail || "تعذّر الاستيراد"); }
    finally { setBusy(false); if (ref.current) ref.current.value = ""; }
  };
  return (
    <div className="space-y-2 rounded-xl border border-emerald-200 bg-emerald-50/50 p-3" data-testid="emp-fields-import">
      <p className="text-sm font-semibold text-emerald-800">قالب الموظفين الكامل (تصدير واستيراد)</p>
      <p className="text-xs text-slate-500">الملف فيه كل موظفيك بكل خانات صفحة الموظف: البيانات الأساسية، والعقد، والوثائق (الرقم وتاريخ الانتهاء لكل وثيقة)، والخانات الخاصة. أي خانة تضيفها في الإعدادات تظهر عموداً جديداً تلقائياً. عدّل وأضف سطوراً لموظفين جدد (يكفي الاسم)، ثم ارفعه. الخانات الفارغة لا تُغيّر شيئاً، ولا تعدّل عمود «معرف النظام».</p>
      <div className="flex flex-wrap gap-2">
        <a href={empFieldsTemplateUrl} data-testid="emp-fields-template" className="inline-flex items-center gap-1.5 rounded-lg border border-emerald-300 bg-white px-3 py-1.5 text-xs font-semibold text-emerald-700 hover:bg-emerald-50">
          <Download className="h-3.5 w-3.5" /> تصدير قالب الموظفين
        </a>
        <label className="inline-flex cursor-pointer items-center gap-1.5 rounded-lg bg-emerald-600 px-3 py-1.5 text-xs font-semibold text-white hover:bg-emerald-700" data-testid="emp-fields-upload">
          {busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <FileSpreadsheet className="h-3.5 w-3.5" />} رفع الملف المعبّأ
          <input ref={ref} type="file" accept=".xlsx,.xls,.csv" className="hidden" data-testid="emp-fields-file" disabled={busy} onChange={(e) => upload(e.target.files?.[0])} />
        </label>
      </div>
      {res && (
        <div className="space-y-1 rounded-lg bg-white p-2 text-xs" data-testid="emp-fields-result">
          <p className="font-semibold text-emerald-700">حُدّث {res.updated} · أُضيف {res.created || 0} موظف جديد · بدون تغيير {res.unchanged}</p>
          {res.not_found.length > 0 && <p className="text-amber-700" data-testid="emp-fields-notfound">سطور بدون اسم لم تُضف ({res.not_found.length}): {res.not_found.slice(0, 8).map((x) => `${x.name || "؟"} (سطر ${x.row})`).join("، ")}</p>}
          {res.errors.map((x) => <p key={x.row} className="text-rose-600">سطر {x.row} — {x.name}: {x.error}</p>)}
        </div>
      )}
    </div>
  );
};
